// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__cOkdx","accordionIttem":"Accordion_accordionIttem__gT4L+","accordionBtn":"Accordion_accordionBtn__v1n8M"};